<template>
    <div>
        <v-card-title class="subheading ml-5 pl-4">Seleccione un rango de fecha</v-card-title>
        <v-card-actions class="justify-center">
            <v-flex xs4 ml-3>
                <date-component
                    label="Fecha Inicio"
                    :date-formatted="params.startDate"
                    :max-date="maxDate"
                    model="startDate"
                    @input="onStartDateChange"
                />
            </v-flex>
            <v-flex xs4 ml-3>
                <date-component
                    label="Fecha Final"
                    :date-formatted="params.endDate"
                    :max-date="maxDate"
                    model="endDate"
                    :readonly="!params.startDate"
                    :min-date="params.startDate"
                    @input="onEndDateChange"
                />
            </v-flex>
            <v-btn class="sales-btn ml-3 mt-4" :disabled="isLoading" outlined color="primary" elevation="2" @click="searchData">
                <v-icon>search</v-icon>
            </v-btn>
        </v-card-actions>

        <!-- LOADING -->
        <div class="loader mt-5" v-if="isLoading">
            <div class="spinner"></div>
        </div>

        <!-- RENDERIZAR LA DATA -->
        <div v-if="!isLoading">
            <v-card
                v-for="(company, index) in dataTemplate"
                :key="index"
                class="pa-4 mb-3 mt-2"
                >
                <v-card-title class="headline pb-2 pt-2">
                    {{ index + 1 }}. {{ company.companyName }}
                </v-card-title>
                <v-card-text>
                    <p><strong>RUC:</strong> {{ company.ruc }}</p>
                    <p><strong>Monto total de la venta:</strong> {{ company.amountDocument }}</p>
                    <p><strong>Total de Documentos:</strong> {{ company.totalDocument }}</p>
                    <p><strong>Fecha Inicio Documento:</strong> {{ company.dateDocumentInit ? formatDate(company.dateDocumentInit) : '-' }}</p>
                    <p><strong>Primer documento realizado:</strong> {{ company.documentNumberInit }}</p>
                    <p><strong>Fecha Fin Documento:</strong> {{ company.dateDocumentEnd ? formatDate(company.dateDocumentEnd) : '-' }}</p>
                    <p><strong>Ultimo documento realizado:</strong> {{ company.documentNumberEnd }}</p>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>
<script>
import dateComponent from '@/components/shared/date-component';
import { format } from 'date-fns';

export default {
    name: 'company-sales',
    components: {
        dateComponent,
    },
    data() {
        return {
            isLoading: false,
            params: {
                startDate: null,
                endDate: null,
            },
            dataTemplate: [],
            maxDate: new Date().toISOString().split('T')[0],
        };
    },
    methods: {
        formatDate(date) {
            return new Date(date).toLocaleDateString('es-PE').replace(/\//g, '/');
        },
        setParams({ model, value }) {
			this.params[model] = format(value.value, 'YYYY-MM-DD');
		},
        onStartDateChange(date) {
            this.setParams({ model: 'startDate', value: date });
            // Limitar fecha final a 30 días después de la fecha de inicio
            // const endDateLimit = new Date(date.value);
            // endDateLimit.setDate(endDateLimit.getDate() + 30);
            // this.params.endDate = this.params.endDate > endDateLimit ? endDateLimit : this.params.endDate;
        },
        onEndDateChange(date) {
            this.setParams({ model: 'endDate', value: date });
        },
        async searchData() {
            try {
                this.isLoading = true;
                const body = {
					companiesIds: [this.rowTemplate.id],
					startDate: this.params.startDate ? this.params.startDate : undefined,
					endDate: this.params.endDate ? this.params.endDate : undefined,
				};
				const code = this.templates.find(t => t.codeTemplate === this.idDistribution).id;
				const response = await this.$http.post(`template/${code}/sales`, body);
                this.dataTemplate = response.data.data;
            } catch (err) {
                this.showError();
            } finally {
                this.isLoading = false;
            }
        },
    },
    props: {
        rowTemplate: {
            type: Object,
        },
        templates: {
            type: Array,
        },
        idDistribution: [Number, String],
    },
};
</script>
<style scoped>
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>


// WEBPACK FOOTER //
// src/components/companies/company-sales.vue